export default __webpack_public_path__ + "static/media/Figure-14.c9bcf275.jpg";